import React from 'react';
import {
  Content,
  Container,
  EventInformation,
  Minute,
  DataContainer,
  Text,
} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Line, Typography} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import {InfoOutlined} from '@mui/icons-material';

const MatchEventChance = ({event}) => {
  const standingMessage = `Großchance für ${event.team?.name?.middle ?? 'Unbekannt'}`;
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;

  const showPlayerName = event.primaryRole?.player ? (
    <LinkOnComponent to={`/player/${event.primaryRole.player.slug}`}>
      <Typography variant='body2'>
        {event.primaryRole.player.firstName} {event.primaryRole.player.lastName}
      </Typography>
    </LinkOnComponent>
  ) : null;

  return (
    <Content>
      <Container>
        <EventInformation>
          <Minute variant='subheading2' component='span'>
            {time}
          </Minute>
          <InfoOutlined style={{color: COLORS.darkGrey, fontSize: 16}} />
        </EventInformation>
        <DataContainer>
          <Typography variant='body1'>{standingMessage}</Typography>
          {showPlayerName}
          <Text withPadding variant='body2'>
            {event.text}
          </Text>
        </DataContainer>
      </Container>
      <Line />
    </Content>
  );
};

export default MatchEventChance;
